import { render } from "./FooterNavSubmenu.vue?vue&type=template&id=4f5683ab&scoped=true&lang=pug"
import script from "./FooterNavSubmenu.vue?vue&type=script&lang=ts"
export * from "./FooterNavSubmenu.vue?vue&type=script&lang=ts"

import "./FooterNavSubmenu.vue?vue&type=style&index=0&id=4f5683ab&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-4f5683ab"

export default script